import {observer} from "mobx-react";
import {Container, ContentList, SubContentList,} from "./styled";
import React, {useEffect} from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import TableBackup from "@dropDesk/presentation/pages/company_configurations/ui/backup/table";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {BackupData} from "@dropDesk/domain/entities/ticket/backup/backup_data";
import {useBetween} from "use-between";
import {
    useModalBackup
} from "@dropDesk/presentation/pages/company_configurations/ui/backup/modals/handle_change_visible";
import ModalsBackup from "@dropDesk/presentation/pages/company_configurations/ui/backup/modals";
import SearchBar from "@dropDesk/presentation/pages/company_configurations/ui/backup/search_bar";

const BackupConfiguration = observer(
    ({
         tableBackups,
         getDataFromPage,
         loading,
         initialize,
         downloadBackup,
         loadingTable,
         startBackup
     }: {
        tableBackups: ListPaginationEntity<BackupData>,
        getDataFromPage: (page: number) => void,
        loading: boolean
        loadingTable: boolean
        initialize: () => Promise<void>,
        startBackup: () => Promise<void>,
        downloadBackup: (backupData:BackupData) => void,
    }) => {


        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        useEffect(() => {
            initialize().then();
        }, []);

        const {
            setVisibleModalDownloadBackup,
            setVisibleModalStartBackup
        } = useBetween(useModalBackup);

        return (
            <Container background={colors.onBackground} heightShowingHeaderInfo={appController.heightShowingHeaderInfo}>
                <ContentList>
                    <SearchBar
                        handleClickStartBackup={() => setVisibleModalStartBackup(true)}
                    />
                    <SubContentList>
                        <TableBackup
                            searchParam={''}
                            loading={loadingTable}
                            tableBackups={tableBackups}
                            getDataFromPage={getDataFromPage}
                            handleClickDownloadBackup={(backupData) => setVisibleModalDownloadBackup({visible: true, backupData})}
                        />
                    </SubContentList>
                </ContentList>
                <ModalsBackup
                    loading={loading}
                    handleStartBackup={() => startBackup()}
                    handleDownloadBackup={(backupData) =>  downloadBackup(backupData)}
                />
            </Container>
        )
    })
export default BackupConfiguration;
